import { render, staticRenderFns } from "./popularList.vue?vue&type=template&id=051a5e66&scoped=true"
import script from "./popularList.vue?vue&type=script&lang=js"
export * from "./popularList.vue?vue&type=script&lang=js"
import style0 from "./popularList.vue?vue&type=style&index=0&id=051a5e66&prod&lang=scss&scoped=true"
import style1 from "./popularList.vue?vue&type=style&index=1&id=051a5e66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a5e66",
  null
  
)

export default component.exports